import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteScreenTitle: {
        id: 'quoteandbind.wizard.residential.quoteScreenTitle',
        defaultMessage: 'Quote'
    },
    paymentRequestFailed: {
        id: 'quoteandbind.wizard.residential.paymentRequestFailed',
        defaultMessage: 'Missing Required Fields'
    },
    sorryYourPaymentCouldNotBeProcessedAtThisTime: {
        id: 'quoteandbind.wizard.residential.sorryYourPaymentCouldNotBeProcessedAtThisTime',
        defaultMessage: 'Please enter the Estimated Replacement Cost and Estimated Actual Cash Value before editing any other fields.',
    },
    documentMessage: {
        id: 'quoteandibind.wizard.residential.documentMessage',
        defaultMessage: 'The Quote Summary will be available shortly on the documents.',
    },
    documentConfirmButton: {
        id: 'quoteandibind.wizard.residential.Go to Documents',
        defaultMessage: 'Go to Documents',
    },
    documentContinueButton: {
        id: 'quoteandibind.wizard.residential.Continue',
        defaultMessage: 'Continue',
    },
    documentErrorMessage: {
        id: 'quoteandibind.wizard.residential.The transaction must be quoted to generate print quote summary.',
        defaultMessage: 'The transaction must be quoted to generate print quote summary.',
    },
    documentErrorTitle: {
        id: 'quoteandibind.wizard.residential.Transaction Not Quoted',
        defaultMessage: 'Transaction Not Quoted',
    },
    documentCloseButton: {
        id: 'quoteandibind.wizard.residential.Close',
        defaultMessage: 'Close',
    },
    cancelQuote: {
        id: 'quoteandibind.wizard.residential.Cancel Quote',
        defaultMessage: 'Are you sure you want to exit?',
    },
    cancelMessage: {
        id: 'quoteandibind.wizard.residential.Are you sure you want to cancel the new quote?',
        defaultMessage: 'The information you entered will be stored as a draft quote. You must complete and submit this quote within 30 days of its Effective Date, or it will expire.',
    },
    cancelMessageButton: {
        id: 'quoteandibind.wizard.residential.Cancel',
        defaultMessage: 'Cancel',
    },
    cancelMessageYesButton: {
        id: 'quoteandibind.wizard.residential.Yes',
        defaultMessage: 'Yes',
    },
    continueLabel: {
        id: 'quoteandbind.wizard.residential.continueLabel',
        defaultMessage: 'Continue'
    },
    noCoveragesSelected: {
        id: 'quoteandbind.wizard.residential.noCoveragesSelected',
        defaultMessage: 'Please select at least one coverage.'
    },
    quotePremiumCardMessage:{
       id: "quoteandibind.wizard.residential.quoteInstructions",
       defaultMessage: "Please select coverage options and click the 'Calculate Premium' button to quote this Submission"
    },
    quoteRenewalPremiumCardMessage:{
        id: "quoteandibind.wizard.residential.renewal.quoteInstructions",
        defaultMessage: "Please select coverage options and click the 'Calculate Premium' button to quote this Renewal."
    },
    quoteChangePremiumCardMessage:{
        id: "quoteandibind.wizard.residential.change.quoteChangePremiumCardMessage",
        defaultMessage: "Please select coverage options and click the 'Calculate Premium' button to quote this PolicyChange."
    },
    coinsuranceWaiverLimitExceedsACVError: {
        id: 'quoteandbind.wizard.residential.changeOrRenewal.Coinsurance cannot be waived when the Structure Limit exceeds the Actual Cash Value. Please contact Underwriting.',
        defaultMessage: 'Coinsurance cannot be waived when the Structure Limit exceeds the Actual Cash Value. Please contact Underwriting.'
    },
    quotePageNotificationDefaultText: {
        id: 'quoteandibind.wizard.residential.The amount of insurance does not meet the minimum requirement for replacement cost coverage',
        defaultMessage: 'The amount of insurance does not meet the minimum requirement for replacement cost coverage'
    },
    quotePageNotificationInfoBanner: {
        id: 'quoteandbind.wizard.residential.changeOrRenewal.The amount of insurance on the Structure meets the minimum requirement for Replacement Cost Coverage.',
        defaultMessage: 'The amount of insurance on the Structure meets the minimum requirement for Replacement Cost Coverage.'
    }
});
